export function extractErrorMessage(error: unknown): string | null {
    console.log('error check', error, typeof error);
    if (!error || error === null) {
        return null;
    }

    return typeof error === 'string' ? error : (error as Error).message;
}
